import * as React from 'react';
import {cn} from '../lib/cn';
import {useCarouselContext} from './CarouselContext';

export const CarouselSlide = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<'div'>
>(({className, ...props}, ref) => {
  const {registerSlide} = useCarouselContext('CarouselSlide');

  React.useEffect(() => registerSlide(), [registerSlide]);

  return (
    <div
      ref={ref}
      data-slot="carousel-slide"
      className={cn('flex h-full w-full shrink-0 items-center justify-center', className)}
      {...props}
    />
  );
});

CarouselSlide.displayName = 'CarouselSlide';
